import { StartingMaterialPriceItem } from '@retro-ui/shared';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { apiQueryClient } from '@f/api-client';

export type PriceMap = Record<string, StartingMaterialPriceItem[]>;

interface UseStartingMaterialPriceOptions {
  smilesList: string[];
  maxPrice?: number;
  maxPricePerGram?: number;
}

export function useStartingMaterialPrice(options: UseStartingMaterialPriceOptions): PriceMap {
  const { smilesList, maxPrice, maxPricePerGram } = options;

  const datasets = useSelector((state: any) => state.startingMaterial.dataset.data);

  const queryKey = ['starting-material-price', datasets, smilesList, maxPrice, maxPricePerGram];
  const priceQuery = apiQueryClient.startingMaterials.fetchPricing.useQuery(
    queryKey,
    {
      query: { smilesList, maxPrice, maxPricePerGram },
    },
    {
      staleTime: Infinity,
      queryKey,
    }
  );

  const priceMap = (priceQuery.data?.body ?? []).reduce((acc, pricing, idx) => {
    return {
      ...acc,
      [smilesList[idx]]: pricing,
    };
  }, {});

  return priceMap;
}
